import { useState, useEffect, useRef } from "react";
import Accordion from "react-bootstrap/Accordion";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Papa from "papaparse";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";

import { api } from "./pureFunctions"

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
import { localCache } from "./globalVariables";
registerLocale("de", de);

const myColumns = {
   KdNr: "KdNr",
   Name: "Name",
   Vorname: "Vorname",
   ind_3094_Feld_adressen99: "Zuständigkeit",
   ind_3072_Feld_adressen90: "Gutschein-Prio",
   ind_2576_Feld_adressen73: "Akquisestufe",
   Letzte_Aktion: "Letzte Aktion",
   ind_2928_Feld_adressen82: "Letzter Anruf",
   ind_3080_Feld_adressen93: "Anrufanzahl",
   ind_2586_Feld_adressen78: "Wunschzeitraum Anruf",
   Benutzer: "Betreuer",
};

const host = import.meta.env.PROD ? "" : "http://localhost:8080";

export default function AdressUebersicht({ user, setUser }) {
   const [veranstaltungsdatum, setVeranstaltungsdatum] = useState(() => {
      const cachedData = localStorage.getItem(localCache.veranstaltungsdatum);
      return cachedData ? new Date(cachedData) : "";
   });
   const [allvisitors, setAllVisitors] = useState([]);
   const [visitors, setVisitors] = useState([]);
   const [angemeldet, setAngemeldet] = useState(0);
   const [anwesend, setAnwesend] = useState(0);
   const [gutscheinanzahl, setGutscheinanzahl] = useState();
   const [gesamtakquisekontakte, setGesamtAkquiseKontakte] = useState();
   const [searchquery, setSearchQuery] = useState("");
   const [regex, setRegex] = useState();
   const [fieldConfiguration, setFieldConfiguration] = useState();
   const [gutscheinFilter, setGutscheinFilter] = useState("alle");
   const [clickedRows, setClickedRows] = useState({});
   const [sortByOne, setSortByOne] = useState({});
   const [sortByTwo, setSortByTwo] = useState({});

   function getVisitors(mydate) {
      const newdate = new Date(mydate);
      var year = newdate.getFullYear();
      var month = newdate.getMonth() + 1;
      if (month <= 9) month = "0" + month;
      var day = newdate.getDate();
      if (day <= 9) day = "0" + day;
      const datestring = day + "." + month + "." + year;

      api.post( "/api/getveranstaltungsaddresses", { veranstaltungsdatum: datestring }).then((data) => {

         let gesamtpersonenanzahl = 0;
         let gesamtgutscheinanzahl = 0;
         let gesamtakquisekontakte = 0;
         const visitordata = data.data.map((item, index) => {

            let leadverlauf=false
            console.log(item);
            try {
                leadverlauf = JSON.parse("[" + item.elements.ind_3084_Feld_adressen95.trim().slice(0, -1) + "]");
            } catch (error) {
               
            }
           
            // console.log(leadverlauf);
            const personenanzahl = leadverlauf?parseInt(leadverlauf.find((element) => element.datum === datestring).anzahl):0
            gesamtgutscheinanzahl += item.elements.ind_3072_Feld_adressen90 ? 1 : 0;
            gesamtakquisekontakte += item.elements.ind_2588_Feld_adressen76 ? 1 : 0;
            gesamtpersonenanzahl += personenanzahl;
            return {
               ...item["elements"],
               personenanzahl: personenanzahl,
               index: index,
            };
         });
         // console.log(visitordata);
         console.log("Personenanzahl: " + gesamtpersonenanzahl);
         setAngemeldet(gesamtpersonenanzahl);
         setGutscheinanzahl(gesamtgutscheinanzahl);
         setGesamtAkquiseKontakte(gesamtakquisekontakte);

         setVisitors(visitordata);
         setAllVisitors(visitordata);

         api.post( "/api/getFieldConfiguration", {
               fieldList: ["ind_3094_Feld_adressen99", "ind_3072_Feld_adressen90", "ind_2576_Feld_adressen73"],
               modules: ["address"],
            })
            .then((data) => {
               console.log(data.data);
               setFieldConfiguration(data.data[0].elements);
            })
            .catch((err) => {
               console.log(JSON.stringify(err.response.data, null, 1));
               localStorage.removeItem(localCache.build);
               return { error: JSON.stringify(err.response.data, null, 1) };
               // setErrorMessage(JSON.stringify(err.response.data, null, 1));
            });
      });
      localStorage.setItem(localCache.veranstaltungsdatum, mydate);
      setVeranstaltungsdatum(mydate);
   }

   useEffect(() => {
      if (veranstaltungsdatum) {
         getVisitors(veranstaltungsdatum);
      }
   }, []);

   useEffect(() => {
      const newregex = new RegExp("(.*" + searchquery.toLowerCase() + ")", "g");
      setRegex(newregex);

      setVisitors(
         allvisitors.filter(
            (element) => !(element.Vorname.toLowerCase() + " " + element.Name.toLowerCase()).search(newregex)
         )
      );
   }, [searchquery]);

   function handleSearch(e) {
      e.preventDefault();
      console.log(regex);

      console.log(visitors);

      if (visitors.length === 1) {
         const prev = structuredClone(allvisitors);
         prev[visitors[0].index].isChecked = !prev[visitors[0].index].isChecked;
         setAllVisitors(prev);

         setAnwesend(
            (prevanwesend) =>
               prevanwesend +
               (prev[visitors[0].index].isChecked
                  ? parseInt(prev[visitors[0].index].personenanzahl)
                  : -parseInt(prev[visitors[0].index].personenanzahl))
         );
         setSearchQuery("");
      }
   }

   function filterAdressen(myFilterObject) {
      if (myFilterObject.gutschein) setGutscheinFilter(myFilterObject.gutschein);

      setVisitors(() =>
         allvisitors.filter((item) =>
            myFilterObject.gutschein === "alle"
               ? item
               : myFilterObject.gutschein === "mit"
                 ? item.ind_3072_Feld_adressen90
                 : myFilterObject.gutschein === "ohne"
                   ? item.ind_3072_Feld_adressen90 === ""
                   : false
         )
      );
   }

   async function goToOnOffice(myAddressId) {
      await api.post("/api/getOoLink", { id: myAddressId, resourcetype: "address" })
         .then((estateooLink) => {
            console.log(estateooLink.data.url);
            window.open(estateooLink.data.url, "_blank");
         })
         .catch((err) => {
            console.log(JSON.stringify(err.response.data, null, 1));
            // setErrorMessage(JSON.stringify(err.response.data, null, 1));
         });

      setClickedRows((prev) => ({ ...prev, [myAddressId]: true }));
   }

   function sortRows(myParameter) {
      let sortBool = 1;
      let mySorter = structuredClone(sortByOne);

      if (mySorter) {
         if (mySorter[myParameter] != undefined) {
            mySorter[myParameter] *= -1;
         } else mySorter = { [myParameter]: 1 };
      } else {
         mySorter = { [myParameter]: 1 };
      }

      if (myParameter === "ind_2576_Feld_adressen73" && fieldConfiguration) {
         setVisitors((prev) => {
            return prev.sort((a, b) => {
               if (fieldConfiguration[myParameter].permittedvalues[a[myParameter]]>fieldConfiguration[myParameter].permittedvalues[b[myParameter]]) return mySorter[myParameter];
               else if (fieldConfiguration[myParameter].permittedvalues[a[myParameter]]<fieldConfiguration[myParameter].permittedvalues[b[myParameter]]) return -1*mySorter[myParameter];
               else return 0;
            });
         });
      } else {
         setVisitors((prev) => {
            return prev.sort((a, b) => {
               if (a[myParameter] > b[myParameter]) return  mySorter[myParameter];
               else if (a[myParameter] < b[myParameter]) return -1*mySorter[myParameter];
               else return 0;
            });
         });
      }
      setSortByOne(mySorter);
   }

   return (
      <>
         <div className="m-5">
            <title>{"VA "+(veranstaltungsdatum && veranstaltungsdatum.toLocaleDateString())}</title>
            <h2>Veranstaltungsdatum {veranstaltungsdatum && veranstaltungsdatum.toLocaleDateString()}</h2>
            <Form>
               <Row className="mb-3">
                  <Form.Group as={Col} controlId="formGridmaxpreis">
                     {/* <Form.Label>Auswahl</Form.Label> */}
                     <DatePicker
                        selected={veranstaltungsdatum}
                        /* showIcon */
                        showTimeCaption={false}
                        dateFormat="dd.MM.yyyy"
                        onChange={(date) => getVisitors(date)}
                        locale="de"
                        /* isClearable */
                        className="custom-date-inputfield"
                        calendarClassName="custom-date-calendar"
                        placeholderText=""
                     />
                  </Form.Group>
               </Row>
            </Form>
            {allvisitors.length > 0 && (
               <div className="mb-2">
                  <div className="mb-2">
                     <Button
                        onClick={() => filterAdressen({ gutschein: "alle" })}
                        variant={gutscheinFilter === "alle" ? "dark" : "secondary"}
                        className="me-1"
                     >
                        {allvisitors.length} Akquise-Kontakte
                     </Button>

                     <Button
                        onClick={() => filterAdressen({ gutschein: "ohne" })}
                        variant={gutscheinFilter === "ohne" ? "dark" : "secondary"}
                        className="me-1"
                     >
                        {gesamtakquisekontakte - gutscheinanzahl} Kontakte ohne Gutschein
                     </Button>

                     <Button
                        onClick={() => filterAdressen({ gutschein: "mit" })}
                        variant={gutscheinFilter === "mit" ? "dark" : "secondary"}
                     >
                        {gutscheinanzahl} Gutscheine ausgefüllt
                     </Button>
                  </div>
                  <div className="immobilienuebersicht">
                     <table>
                        <thead>
                           <tr className="text-start">
                              {Object.keys(myColumns).map((column) => (
                                 <th style={{cursor: "pointer", ...sortByOne[column]===1?{backgroundColor:"#38c", color:"#fff"}:(sortByOne[column]===-1?{backgroundColor:"#2c7", color:"#fff"}:{})}} onClick={() => sortRows(column)}>
                                    {myColumns[column]} {sortByOne[column]===-1&&"▼"}{sortByOne[column]===1&&"▲"}
                                 </th>
                              ))}
                           </tr>
                        </thead>
                        <tbody>
                           {visitors.map((visitor, index) => {
                              return (
                                 <>
                                    <tr
                                       style={{ cursor: "pointer", opacity: clickedRows[visitor.id] ? 0.7 : 1 }}
                                       className="text-start"
                                       onClick={() => goToOnOffice(visitor.id)}
                                    >
                                       <td>{visitor.KdNr}</td>
                                       <td>{visitor.Name}</td>
                                       <td>{visitor.Vorname}</td>
                                       <td>
                                          {fieldConfiguration &&
                                             fieldConfiguration["ind_3094_Feld_adressen99"].permittedvalues[
                                                visitor.ind_3094_Feld_adressen99
                                             ]}
                                       </td>
                                       <td>
                                          {fieldConfiguration &&
                                             fieldConfiguration["ind_3072_Feld_adressen90"].permittedvalues[
                                                visitor.ind_3072_Feld_adressen90
                                             ]}
                                       </td>
                                       <td>
                                          {fieldConfiguration &&
                                             fieldConfiguration["ind_2576_Feld_adressen73"].permittedvalues[
                                                visitor.ind_2576_Feld_adressen73
                                             ]}
                                       </td>
                                       <td>
                                          {visitor.Letzte_Aktion && new Date(visitor.Letzte_Aktion).toLocaleString()}
                                       </td>
                                       <td>{visitor.ind_2928_Feld_adressen82}</td>
                                       <td>{visitor.ind_3080_Feld_adressen93}</td>
                                       <td>{visitor.ind_2586_Feld_adressen78}</td>
                                       <td>{visitor.Benutzer}</td>
                                    </tr>
                                 </>
                              );
                           })}
                        </tbody>
                     </table>
                  </div>
               </div>
            )}
         </div>
      </>
   );
}
